import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(!window.isMobile) {
            this.id = this.el.getAttribute('data-module-rotate');
            this.$animatedEls = this.$('el');

            this.initTimeline();
        }
    }

    progress(progress) {
        this.timeline.progress(progress * 2);
    }

    initTimeline() {
        this.timeline = new gsap.timeline();

        this.$animatedEls.forEach($el => {
            this.timeline.fromTo($el,
                JSON.parse($el.getAttribute('data-from')),
                JSON.parse($el.getAttribute('data-to')),
                $el.getAttribute('data-start')
            )
        });

        this.timeline.pause();
    }
}
